/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskResultsListDismissed } from "../funcs/riskResultsListDismissed.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListRiskResultsResult } from "../models/components/listriskresultsresult.js";
import {
  ListDismissedRiskResultsRequest,
  ListDismissedRiskResultsSecurity,
  Reasons,
} from "../models/operations/listdismissedriskresults.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskListDismissedResultsQueryData = ListRiskResultsResult;

export function prefetchRiskListDismissedResults(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListDismissedRiskResultsRequest | undefined,
  security?: ListDismissedRiskResultsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskListDismissedResultsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskListDismissedResultsQuery(
  client$: GramCore,
  request?: ListDismissedRiskResultsRequest | undefined,
  security?: ListDismissedRiskResultsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RiskListDismissedResultsQueryData>;
} {
  return {
    queryKey: queryKeyRiskListDismissedResults({
      cursor: request?.cursor,
      limit: request?.limit,
      reasons: request?.reasons,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskListDismissedResultsQueryFn(
      ctx,
    ): Promise<RiskListDismissedResultsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskResultsListDismissed(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskListDismissedResults(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    reasons?: Array<Reasons> | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "results", "listDismissed", parameters];
}
